const BaseUrl = '/service/';
const Title = 'IACAS JAS';
const WsUrl = 'wss://tpsjas.mail2typeb.com/ws'
const BaseColor = '#f15828';

module.exports = {
    BaseUrl,
    Title,
    WsUrl,
    BaseColor
}
